var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['bto-sb-message', `bto-sb-message-${_vm.type}`,'bto-sb-fadeindown']},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }